import request from "@/helper/request";


//获取小程序二维码
export function getUnlimitedQRCode(scene) {
  return request({
    url: "/api/miniProgram/getUnlimitedQRCode",
    method: "get",
    responseType: 'blob',
    params: {
      scene: scene
    }
  });
}


//web端轮询扫描二维码
export function checkSceneLoginStatus(scene) {
  return request({
    url: "/api/miniProgram/checkSceneLoginStatus",
    method: "get",
    params: {
      scene: scene
    }
  });
}

//获取大图
export function getBannerList() {
  return request({
    url: "/open/Jobhb/getBannerList",
    method: "get"
  });
}

//图片预览
export function getPreviewUrl(objectKey) {
  return request({
    url: "/open/Jobhb/getPreviewUrl",
    method: "get",
    params: {
      objectKey: objectKey
    }
  });
}

//获取条形图
export function getBarPictureList() {
  return request({
    url: "/open/Jobhb/getBarPictureList",
    method: "get"
  });
}

//获取公告
export function getCommentList() {
  return request({
    url: "/open/Jobhb/getCommentList",
    method: "get"
  });
}

//获取公告列表
export function getCommentListWithPage(data) {
  return request({
    url: "/open/Jobhb/getCommentListWithPage",
    method: "get",
    params: data
  });
}

//获取公告详情
export function getCommentById(cmCommentId) {
  return request({
    url: "/open/Jobhb/getCommentById",
    method: "get",
    params: {
      cmCommentId: cmCommentId
    }
  });
}


//专场列表
export function getRegionList() {
  return request({
    url: '/open/Jobhb/getRegionList',
    method: 'get',
  })
}


//招聘项目列表
export function getReRecruitProjectList(regionId) {
  return request({
    url: '/open/Jobhb/getReRecruitProjectList',
    method: 'get',
    params: {
      regionId: regionId
    }
  })
}


//查询单个招聘项目
export function getSingleRecruitProject(reRecruitProjectId) {
  return request({
    url: '/api/miniProgram/getSingleRecruitProject',
    method: 'get',
    params: {
      reRecruitProjectId: reRecruitProjectId
    }
  })
}


//获取项目内公司列表
export function getProjectCompanyList(data) {
  return request({
    url: '/api/miniProgram/getProjectCompanyList',
    method: 'get',
    params: data
  })
}


//获取图形验证码
export function getCaptchaImage() {
  return request({
    url: "/open/Jobhb/captchaImage",
    method: 'get',
    timeout: 20000
  });
}


//发送验证码
export function sendCode(data) {
  return request({
    url: "/open/Jobhb/sendCode",
    method: "post",
    data:data
  });
}

//验证码登录
export function verifyCodeLogin(phoneNumber, verifyCode) {
  return request({
    url: "/open/Jobhb/verifyCodeLogin",
    method: "post",
    params: {
      phoneNumber: phoneNumber,
      verifyCode: verifyCode
    }
  });
}

//注册
export function register(phoneNumber, verifyCode, userPassword) {
  return request({
    url: "/open/Jobhb/register",
    method: "post",
    params: {
      phoneNumber: phoneNumber,
      verifyCode: verifyCode,
      userPassword: userPassword
    }
  });
}

//密码登录
export function passwordLogin(phoneNumber, userPassword) {
  return request({
    url: "/open/Jobhb/passwordLogin",
    method: "post",
    params: {
      phoneNumber: phoneNumber,
      userPassword: userPassword
    }
  });
}


//忘记密码
export function editPassword(phoneNumber, verifyCode, newPassword) {
  return request({
    url: "/open/Jobhb/editPassword",
    method: "post",
    params: {
      phoneNumber: phoneNumber,
      verifyCode: verifyCode,
      newPassword: newPassword
    }
  });
}

//行业
export function getIndustryTree() {
  return request({
    url: "/open/Jobhb/getIndustryTree",
    method: "get"
  });
}

//最新岗位
export function getLatestPositionList() {
  return request({
    url: "/open/Jobhb/getLatestPositionList",
    method: "get",
    params: {
      size: "12"
    }
  });
}

//热门岗位
export function getHotPositionList() {
  return request({
    url: "/open/Jobhb/getHotPositionList",
    method: "get",
    params: {
      size: "12"
    }
  });
}

//热门单位
export function getHotCompanyList() {
  return request({
    url: "/open/Jobhb/getHotCompanyList",
    method: "get",
    params: {
      limit: "6"
    }
  });
}

//获取岗位列表
export function getJobsList(data) {
  return request({
    url: "/api/jobs/jobsList",
    method: "post",
    params: data
  });
}

//获取岗位详情
export function getJobs(jobId) {
  return request({
    url: "/api/jobs/jobs",
    method: "post",
    params: {
      jobId: jobId
    }
  });
}

//获取公司信息详情
export function getCompany(companyId) {
  return request({
    url: "/api/company/company",
    method: "post",
    params: {
      companyId: companyId
    }
  });
}

//获取公司信息列表
export function getCompanyList(data) {
  return request({
    url: "/api/company/companyList",
    method: "post",
    params: data
  });
}

//获取推荐岗位
export function getRecomJobs(data) {
  return request({
    url: "/api/jobs/recomJobs",
    method: "post",
    data: data
  });
}

//获取岗位投递状态
export function getJobApplyStatus(jobId) {
  return request({
    url: "/api/miniProgram/getJobApplyStatus/" + jobId,
    method: "get"
  });
}

//投递岗位
export function applyForJob(jobId, reMiniProgramAttachmentList) {
  return request({
    url: "/api/miniProgram/applyForJob",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data: {
      jobId: jobId,
      reMiniProgramAttachmentList: reMiniProgramAttachmentList
    }
  });
}

//投递岗位信息列表
export function jobRelationList(data) {
  return request({
    url: "/api/miniProgram/jobRelationList",
    method: "post",
    params: data
  });
}

//行业
export function getIndustryList() {
  return request({
    url: "/open/Jobhb/getIndustryList",
    method: "get"
  });
}

//个人信息回显
export function personalInfo() {
  return request({
    url: "/api/miniProgram/personalInfo",
    method: "get"
  });
}

//个人信息提交
export function personalInfoCommit(data) {
  return request({
    url: "/api/miniProgram/personalInfoCommit",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data: data
  });
}

//工作经历提交
export function workExperienceCommit(data) {
  return request({
    url: "/api/miniProgram/workExperienceCommit",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data: data
  });
}

//行业
export function reTradeList() {
  return request({
    url: "/api/miniProgram/reTradeList",
    method: "get"
  });
}

//大学专业
export function undergraduateMajorList() {
  return request({
    url: "/api/miniProgram/undergraduateMajorList",
    method: "get"
  });
}

//教育经历提交
export function educationExperienceCommit(data) {
  return request({
    url: "/api/miniProgram/educationExperienceCommit",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data: data
  });
}

//项目经历提交
export function projectExperienceCommit(data) {
  return request({
    url: "/api/miniProgram/projectExperienceCommit",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data: data
  });
}

//工作经历删除
export function deleteWorkExperience(ids) {
  return request({
    url: "/api/miniProgram/deleteWorkExperience/" + ids,
    method: "delete"
  });
}

//教育经历删除
export function deleteEducationExperience(ids) {
  return request({
    url: "/api/miniProgram/deleteEducationExperience/" + ids,
    method: "delete"
  });
}

//项目经历删除
export function deleteProjectExperience(ids) {
  return request({
    url: "/api/miniProgram/deleteProjectExperience/" + ids,
    method: "delete"
  });
}

//上传简历
export function resumeUpload(resume) {
  return request({
    url: "/api/miniProgram/resumeUpload",
    method: "get",
    params: {
      resume: resume
    }
  });
}

// 简历下载
export function download(resume) {
  return request({
    url: "/api/miniProgram/download",
    method: "get",
    params: {
      resume: resume
    },
    responseType: "blob"
  });
}

//产品体系
export function getProductSystemTree(name) {
  return request({
    url: "/open/Jobhb/getProductSystemTree",
    method: "get",
    params: {
      name: name
    }
  });
}

//地域
export function getCmLocation() {
  return request({
    url: "/open/Jobhb/getCmLocation",
    method: "get"
  });
}

//获取video
export function getVideo(url) {
  return request({
    url: "/open/jobhb/cdn/sign",
    method: "get",
    params:{
      uri:url,
    }
  });
}

